import { useState, useEffect } from "react";
import "./css/childrenBooks.css";
import { motion } from "motion/react";
import DivisorDown from "../../components/divisorDown/divisorDown";
import ButtonLine from "../../components/buttonLine/buttonLine";
import CarruselChildren from "../../components/carruselChildren/carruselChildren";

import characterDesign from "../../pages/ChildrenBooks/json/characterDesign.json";
import coverBoosks from "../../pages/ChildrenBooks/json/coverBooks.json";
import ilustrations from "../../pages/ChildrenBooks/json/ilustrations.json";

import Ilustration from "../../components/ilustration /ilustration";
import Modal from "../../components/modals/characterModal/Modal";
import CoverBooksModal from "../../components/modals/coverBooksModal/CoverBooksModal";


const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const ChildrenBooks = () => {
  const isMobile = useIsMobile();
  const chunkSize = isMobile ? 1 : 3;
    
  const chunkSizeWhith = isMobile ? 286 : 376;
  const chunkSizeHeidth = isMobile ? 334 : 424;
  const chunkSizeCoverBooks = isMobile ? 1 : 3;

  const handleOpenModal = () => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("fullscreenModal")
    );
    modal.show();
  };

  const handleOpenCoverModal = () => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("fullscreenCoverModal")
    );
    modal.show();
  };

  return (
    <motion.div
      key={"empty"}
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="row justify-content-center text-center mt-4">
        <div className="col-12">
          <div className="color-text-sofia-40-hv responsive-title">
            Children’s book Illustration
          </div>  

          <div className="color-text-barlow-regular-18-hv responsive-subtitle">
            Where pictures whisper stories and thoughts come true.
          </div>
        </div>
      </div>

      <div className="margin-divisor-hv mb-1">
        <DivisorDown
          title="Character design"
          subtitle="Character emerge before words."
          text="These are sketches from different projects i have work on, ranging from a preliminary ideas to final approved character."
        />
      </div>

      <CarruselChildren
        books={characterDesign}
        widthComponent={chunkSizeWhith}
        heightComponent={chunkSizeHeidth}
        carouselId="characterDesign"
        numberCards={chunkSize}
        character ={true}
      />

      <div className="col-md-12 d-flex justify-content-center mb-4">
        <ButtonLine text={"See more"} onclick={handleOpenModal} />
        <Modal selectedCharacter={characterDesign} />
      </div>

      <div className="margin-divisor-hv">
        <DivisorDown
          title="Book Covers"
          subtitle="A book cover is more than just a surface; it is the beginning of an adventure. These are some titles I have worked on:"
          text=""
        />
      </div>

      <CarruselChildren
        books={coverBoosks}
        widthComponent={271}
        heightComponent={361}
        carouselId="coverBoosks"
        numberCards={chunkSizeCoverBooks}
        character ={false}
      />

      <div className="col-md-12 d-flex justify-content-center mb-4">
        <ButtonLine
          text={"See more"}
          onclick={handleOpenCoverModal}
        />
        <CoverBooksModal coverBooks={coverBoosks} />
      </div>

      <div className="margin-divisor-hv">
        <DivisorDown
          title="Illustrations"
          subtitle="The art of illustration is a beacon that reveals a world of color, form and meaning."
          text="These are some illustrations from projects I have worked on:"
        />
      </div>

      <div className="margin-botton-hv">
        <Ilustration images={ilustrations} />
      </div>
    </motion.div>
  );
};

export default ChildrenBooks;
